import { 
   getPayPalAccessToken,
   getPayPalSignupLink,
   getPayPalMerchantStatus,
   createPayPalOrder,
   showPayPalOrderDetails,
   refundPayPalCapturedPayment,
   authorizePayPalOrder,
   captureAuthorizedPayPalOrder,
   voidAuthorizedPayPalOrder,
   createReferencedPayPalPayoutItem,
   getReferencedPayPalPayoutItem,
   getTransactionDetails,
   updateTransactionMetadata,
   transitionTransactionOperator,
} from '../util/api';
import * as log from '../util/log';

const handleSuccess = (data) => {
   return data;
};

// TODO: Ideally we should distinct various error types and handle them more gracefully
// but for now just doing generic handling for simplicity
const handleError = (e) => {
   log.error(e, 'paypal-request-failed');
   const error = new Error(`Error response recieved from PayPal: ${e.message ?? e}`);
   error.data = e.data;
   throw error;
};

export const recievePayPalAccessToken = () => {
   return getPayPalAccessToken({}).then(handleSuccess).catch(handleError);
};

export const recievePayPalSignupLink = (payload, token) => {
   const body = {data: {token, payload}};
   return getPayPalSignupLink(body).then(handleSuccess).catch(handleError);
};

export const recievePayPalMerchantStatus = (token, merchantId) => {
   const body = {data: {token, merchantId}};
   return getPayPalMerchantStatus(body).then(handleSuccess).catch(handleError);
};

export const createOrder = (payload, token, merchantId) => {
   const body = {data: {token, payload, merchantId}};
   return createPayPalOrder(body).then(handleSuccess).catch(handleError);
};

export const refundCapturedPayment = (captureId, token, merchantId, refundAmount, paymentInstruction) => {
   const body = {data: {token, captureId, merchantId, refundAmount, paymentInstruction}};
   return refundPayPalCapturedPayment(body).then(handleSuccess).catch(handleError);
};

export const showOrderDetails = (orderId, token, merchantId) => {
   const body = {data: {token, orderId, merchantId}};
   return showPayPalOrderDetails(body).then(handleSuccess).catch(handleError);
};

export const authorizeOrder = (orderId, token, merchantId) => {
   const body = {data: {token, orderId, merchantId}};
   return authorizePayPalOrder(body).then(handleSuccess).catch(handleError);
};

export const captureAuthorizedPayment = (authorizationId, token, merchantId, paymentInstruction) => {
   const body = {data: {token, authorizationId, merchantId, paymentInstruction}};
   return captureAuthorizedPayPalOrder(body).then(handleSuccess).catch(handleError);
};

export const voidAuthorizedPayment = (authorizationId, token, merchantId) => {
   const body = {data: {token, authorizationId, merchantId}};
   return voidAuthorizedPayPalOrder(body).then(handleSuccess).catch(handleError);
};

export const createReferencedPayoutItem = (token, merchantId, captureId) => {
   const body = {data: {token, merchantId, captureId}};
   return createReferencedPayPalPayoutItem(body).then(handleSuccess).catch(handleError);
};

export const getReferencedPayoutItem = (token, merchantId, itemId) => {
   const body = {data: {token, merchantId, itemId}};
   return getReferencedPayPalPayoutItem(body).then(handleSuccess).catch(handleError);
};

export const getSharetribeTransactionDetails = (transactionId) => {
   const body = {data: {transactionId}};
   return getTransactionDetails(body).then(handleSuccess).catch(handleError);
};

export const updateSharetribeTransactionMetadata = (transactionId, metadata) => {
   const body = {data: {transactionId, metadata}};
   return updateTransactionMetadata(body).then(handleSuccess).catch(handleError);
};

export const transitionTxOperator = (transactionId, transition, params) => {
   const body = {data: {transactionId, transition, params}};
   return transitionTransactionOperator(body).then(handleSuccess).catch(handleError);
};
